export const VALIDITY_HISTORY_EXPORT_GENERIC_RETRY_MESSAGE = 'Tente novamente.';